module.exports = __webpack_public_path__ + "img/security.1a01967c.svg";